import { ApiFrontendConfigurationRetrieve200 } from '@rover/rsdk/src/apiClient/latest';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const CONFIGURATION_URL: string = fullApiUrl('frontend/configuration/');
export const SET_LANGUAGE_URL: string = fullApiUrl('i18n/set-language/');
export const get = async (): Promise<ApiFrontendConfigurationRetrieve200> => {
  const ai = getAxiosInstance();
  const params = new URLSearchParams();

  try {
    const { data } = await ai.get<Snakeify<ApiFrontendConfigurationRetrieve200>>(
      CONFIGURATION_URL,
      {
        params,
      }
    );
    return camelize(data, true);
  } catch (e: any) {
    return DefaultAPIErrorHandler(
      e,
      'There was an error while fetching the frontend configuration.'
    );
  }
};
export const setLanguage = async ({ language }: { language: string }): Promise<void> => {
  const ai = getAxiosInstance();

  try {
    await ai.post(SET_LANGUAGE_URL, {
      language,
    });
    return Promise.resolve();
  } catch (error: any) {
    throw DefaultAPIErrorHandler(error, 'There was an error setting your current language');
  }
};
export default {
  get,
  setLanguage,
};
